__turbopack_context__.v({
  "action": "status-page-module__IA6gDG__action",
  "actions": "status-page-module__IA6gDG__actions",
  "main": "status-page-module__IA6gDG__main",
  "primary": "status-page-module__IA6gDG__primary",
});
